const TransferWarehouseIcon = () => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24.6663 18.9282V23.6049C24.6663 26.0322 22.7257 28.0002 20.331 28.0002C17.9363 28.0002 15.9957 26.0322 15.9957 23.6049L16.0037 8.76218C16.0037 6.13218 14.063 4.00018 11.6683 4.00018C9.27367 4.00018 7.33301 6.13218 7.33301 8.76218V18.9288"
            stroke="#FD7333"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M28.6665 20.6669L24.6665 16.6669L20.6665 20.6669"
            stroke="#FD7333"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M28.6663 7.15152C28.6663 10.1215 24.6663 12.6669 24.6663 12.6669C24.6663 12.6669 20.6663 10.1215 20.6663 7.15152C20.6663 6.13886 21.0877 5.16819 21.8377 4.45152C22.6023 3.72996 23.615 3.32973 24.6663 3.33352C25.7177 3.32973 26.7303 3.72996 27.495 4.45152C27.863 4.79872 28.1566 5.21709 28.358 5.68123C28.5593 6.14537 28.6642 6.64559 28.6663 7.15152ZM11.333 23.1515C11.333 26.1215 7.33301 28.6669 7.33301 28.6669C7.33301 28.6669 3.33301 26.1215 3.33301 23.1515C3.33301 22.1389 3.75434 21.1682 4.50434 20.4515C5.26901 19.73 6.28165 19.3297 7.33301 19.3335C8.38437 19.3297 9.39701 19.73 10.1617 20.4515C10.5298 20.7988 10.8234 21.2173 11.0248 21.6815C11.2261 22.1458 11.331 22.6455 11.333 23.1515Z"
            fill="#FC5000"
            stroke="#FC5000"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.6665 9.10135C25.7711 9.10135 26.6665 8.20592 26.6665 7.10135C26.6665 5.99678 25.7711 5.10135 24.6665 5.10135C23.5619 5.10135 22.6665 5.99678 22.6665 7.10135C22.6665 8.20592 23.5619 9.10135 24.6665 9.10135Z"
            fill="#FFF8F5"
        />
        <path
            d="M7.33301 25.0934C8.43758 25.0934 9.33301 24.198 9.33301 23.0934C9.33301 21.9888 8.43758 21.0934 7.33301 21.0934C6.22844 21.0934 5.33301 21.9888 5.33301 23.0934C5.33301 24.198 6.22844 25.0934 7.33301 25.0934Z"
            fill="#FFF8F5"
        />
    </svg>
);
export default TransferWarehouseIcon;
